import { Button, Col, Divider, Form, Input, InputNumber, message, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { SingleImageUpload } from '../../../components/ImageUpload';
import { useEmployees } from './EmpStore';
import api from '../../../api/axios';

function Add(props) {
    let [avatar, setAvatar] = useState('')
    let { addEmployee, statuses, getStatuses } = useEmployees()

    let [regions, setRegions] = useState([])

    useEffect(() => {
        Promise.all([
            api.get("/sdata"),
            getStatuses()
        ]).then(([sdataRes, bizRes]) => {
            setRegions(sdataRes.data.regions || []);
        }).catch(err => {
            console.error("Data load error:", err);
            message.error("Ma'lumotlarni yuklashda xatolik yuz berdi");
        });
    }, []);
    // `phone`, `password`, `fullname`, `roles_id`, `avatar`, `region`, `address`, `user_statusses_id`, `is_employee`

    //  `salary`, `salary_type`, `bussiness_id`, `users_id`, `work_status`, `emp_position_id`
    return (
        <Form layout='vertical' onFinish={(values) => {
            let data = {
                ...values,
                avatar: avatar,
                is_employee: 1,
                roles_id: 11,
                bussiness_id: JSON.parse(localStorage.getItem('mybusiness'))?.id,
                work_status: 1,
                phone: "+998" + values.phone
            }
            console.log(data)
            addEmployee(data)
        }}>
            <Row gutter={16}>
                <Col span={6}>
                    <Form.Item name="avatar" label="Rasm">
                        <SingleImageUpload file={avatar} setFile={setAvatar} name="avatar" maxCount={1} height={120} width={120} />
                    </Form.Item>
                </Col>
                <Col span={18}>
                    <Form.Item name="jshshir" label="JSHSHIR">
                        <Input maxLength={14} type={'number'} />
                    </Form.Item>
                    <Form.Item name={'fullname'} label="Ism familya" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Divider />
                <Col span={8}>
                    <Form.Item name="phone" label="Telefon raqam" rules={[{ required: true }]}>
                        <Input type={'number'} prefix="+998" />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item name={'password'} label="Parol" rules={[{ required: true }]}>
                        <Input.Password />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item name={'user_statusses_id'} label="Xolati">
                        <Select options={statuses.map(status => ({ label: status.name, value: status.id }))} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'region'} label="Viloyat">
                        <Select options={regions.map(region => ({ label: region.nameUz, value: region.id }))} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name={'address'} label="Manzil">
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item name={'salary'} label="Ish haqqi">
                        <Input type={'number'} suffix="so'm" />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item name={'salary_type'} label="Ish haqqi turi">
                        <Select options={[
                            { label: "Oylik", value: "Oylik" },
                            { label: "Kunlik", value: "Kunlik" },
                            { label: "Soatlik", value: "Soatlik" },
                        ]} />
                    </Form.Item>
                </Col>
                <Col span={8}>
                   
                </Col>

            </Row>

            <Form.Item>
                <Button type='primary' htmlType='submit'>Saqlash</Button>
            </Form.Item>

        </Form>
    );
}

export default Add;